<template>
<div class="wrapper" >
  <video-player class="video-player-box"
    ref="videoPlayer"
    :options="playerOptions"
    :playsinline="true"
    customEventName="customstatechangedeventname">
  </video-player>
</div>
</template>

<script>
export default {
  props: ['postsrc', 'autoplay'],
  data () {
    return {
      playerOptions: {
        muted: false,
        autoplay: this.autoplay,
        language: 'en',
        controlBar: {
          fullscreenToggle: false
        },
        inactivityTimeout: 0,
        fluid: true,
        sources: [{
          type: 'audio/mp3',
          src: '/mp3/A-Audio.mp3'
        }],
        poster: ''
      }
    }
  },
  mounted () {
    this.playerSetSrc(this.postsrc)
  },
  computed: {
    player () {
      return this.$refs.videoPlayer.player
    }
  },
  methods: {
    playerSetSrc (url) {
      this.player.src(url)
    }
  }
}
</script>

<style scoped>

.video-player-box{
  width: 0px;
  height: 0px;
  position: absolute;
  margin-top:-120px;
  margin-left:550px;
  z-index:10;
}

@media all and (max-width: 981px) {
  .video-player-box{
    width: 0px;
    height: 0px;
    position: absolute;
    margin-top:-350px;
    margin-left:50px;
    z-index:10;
  }
}
@media all and (min-width: 737px) and (max-width: 980px) {

  .video-player-box{
    width: 0px;
    height: 0px;
    position: absolute;
    margin-top:-350px;
    margin-left:200px;
    z-index:10;
  }

}
@media all and (max-width: 736px) {
  .video-player-box{
    width: 0px;
    height: 0px;
    position: absolute;
    margin-top:-250px;
    margin-left:50px;
    z-index:10;
  }
}
@media all and (max-width: 414px) {
  .video-player-box{
    width: 0px;
    height: 0px;
    position: absolute;
    margin-top:-275px;
    margin-left:80px;
    z-index:10;
  }
}
@media all and (max-width: 375px) {
  .video-player-box{
    width: 0px;
    height: 0px;
    position: absolute;
    margin-top:-220px;
    margin-left:50px;
    z-index:10;
  }
}

@media all and (max-width: 360px) {
  .video-player-box{
    width: 0px;
    height: 0px;
    position: absolute;
    margin-top:-250px;
    margin-left:50px;
    z-index:10;
  }
}

@media all and (max-width: 346px) {
  .video-player-box{
    width: 0px;
    height: 0px;
    position: absolute;
    margin-top:-250px;
    margin-left:50px;
    z-index:10;
  }
}
</style>
